import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { DropdownArrowComponent } from './dropdown-arrow.component';

@NgModule({
  declarations: [
    DropdownArrowComponent
  ],
  imports: [
    CommonModule,
    MatSelectModule
  ],
  exports: [
    DropdownArrowComponent
  ]
})
export class DropdownArrowModule { }
